var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"input-value":this.isOrganizationGraduate == 1,"label":"تصفية حسب خريجي الجمعية"},on:{"change":function($event){return _vm.setFilterState($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }